var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.355 0.191406H2.02164C1.4912 0.191406 0.982496 0.40212 0.607423 0.777193C0.232351 1.15227 0.021637 1.66097 0.021637 2.19141V8.85807C0.021637 9.38851 0.232351 9.89721 0.607423 10.2723C0.982496 10.6474 1.4912 10.8581 2.02164 10.8581H11.355C11.8854 10.8581 12.3941 10.6474 12.7692 10.2723C13.1443 9.89721 13.355 9.38851 13.355 8.85807V2.19141C13.355 1.66097 13.1443 1.15227 12.7692 0.777193C12.3941 0.40212 11.8854 0.191406 11.355 0.191406ZM10.9083 1.52474L6.6883 4.69141L2.4683 1.52474H10.9083ZM11.355 9.52474H2.02164C1.84483 9.52474 1.67526 9.4545 1.55023 9.32948C1.42521 9.20445 1.35497 9.03488 1.35497 8.85807V2.35807L6.2883 6.05807C6.4037 6.14462 6.54406 6.19141 6.6883 6.19141C6.83255 6.19141 6.97291 6.14462 7.0883 6.05807L12.0216 2.35807V8.85807C12.0216 9.03488 11.9514 9.20445 11.8264 9.32948C11.7014 9.4545 11.5318 9.52474 11.355 9.52474Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailBlack);
export default __webpack_public_path__ + "static/media/mail-black.5f4289168de619cc739b6b983e95b198.svg";
export { ForwardRef as ReactComponent };